import React, { InputHTMLAttributes, forwardRef } from 'react';

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const CustomDateInput = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ value, onChange, placeholder, ...props }, ref) => {
    
    // Function to format the input value
    const formatInput = (inputValue: string): string => {
      // Remove all non-numeric characters first
      const numericOnly = inputValue.replace(/\D/g, '');
      // Limit to first 6 digits for YY-MM-DD format
      const limitedNumeric = numericOnly.substring(0, 6);
      let formattedValue = '';

      // Format as YY-MM-DD
      if (limitedNumeric.length > 2) {
        formattedValue += limitedNumeric.substring(0, 2) + '-';
        if (limitedNumeric.length > 4) {
          formattedValue += limitedNumeric.substring(2, 4) + '-';
          formattedValue += limitedNumeric.substring(4, 6);
        } else {
          formattedValue += limitedNumeric.substring(2);
        }
      } else {
        formattedValue = limitedNumeric;
      }

      return formattedValue;
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      // You can implement more robust formatting/validation here
      // For this example, we let the parent component handle the actual date parsing
      if (onChange) {
        onChange(event);
      }
    };

    return (
      <input
        {...props}
        ref={ref}
        value={value ? formatInput(value) : ''} // Apply formatting only if value exists
        onChange={handleChange}
        placeholder={placeholder}
        // Prevents browser's native autocomplete which can interfere
        autoComplete="off" 
      />
    );
  }
);

CustomDateInput.displayName = 'CustomDateInput';

export default CustomDateInput;
